import {Alert} from '@mui/material'
import React from 'react'

export const SerialNumberWarning: React.FC = () => (
  <Alert severity="warning">Serial numbers rarely need editing. Only change one if you know exactly why — otherwise, leave this page.</Alert>
)
